export const options = [
  { label: "Editar", value: "editManual" },
  { label: "Revertir", value: "revertPayoff" },
  // Hidden: full payoff option replaced by partial payoff flow
  // { label: "Saldar", value: "payoff" },
  { label: "Saldar", value: "partialPayoff" },
  { label: "Saldar (Cheque)", value: "chequePayoff" },
  { label: "Cambiar Fecha", value: "postpone" },
  { label: "Editar Área", value: "editArea" },
  { label: "Factorizar", value: "factorize" },
  { label: "Revertir Factorizado", value: "revertFactorize" },
  //{ label: "Crear Obligación", value: "fastObligation" },
];
